var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "gfu-navbar-item" },
    [
      _c(
        "base-button",
        {
          attrs: {
            width: "narrow",
            theme: "default",
            "aria-label": _vm.Resources.Layout.NavigationMenuTriggerLabel,
          },
          on: { click: _vm.onOpen },
        },
        [
          _c("base-icon", {
            attrs: { name: "bars", size: "lg", "is-fixed-width": "" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "drawer",
        { attrs: { "is-open": _vm.isDrawerOpen }, on: { close: _vm.onClose } },
        [
          _c("drawer-header", { on: { close: _vm.onClose } }),
          _vm._v(" "),
          _c(
            "div",
            [
              _vm.hasNavigationItems
                ? [
                    _c("mobile-navigation-list", {
                      attrs: {
                        title: _vm.navigationTitle,
                        navigation: _vm.navigationItems,
                      },
                    }),
                    _vm._v(" "),
                    _c("mobile-navigation-separator"),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("mobile-navigation-list", {
                attrs: {
                  title: _vm.Resources.Homepage.ExploreSectionTitle,
                  navigation: _vm.exploreItems,
                },
              }),
              _vm._v(" "),
              _c("mobile-navigation-separator"),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "_flexcol _pa-2 _gap-2" },
                [
                  _c("currency-selector", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.Resources.ProjectHome.DisplayCurrenciesLabel
                        ) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.isDarkModeEnabled
                    ? _c("theme-selector", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.Resources.Layout.ThemeSelectorLabel) +
                            "\n                "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "language-selector",
                    {
                      attrs: {
                        "display-name":
                          _vm.Resources.Layout.LanguageSelectorModalLabel,
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.Resources.Layout.LanguageSelectorModalLabel
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }